import { Adresse } from '@/model/adresse';
import { ArticleLieuDepart } from '@/model/article-lieu-depart';
import { Conditionnement } from '@/model/conditionnement';
import { DateConverter } from '@/model/converters/datesConverters';
import { DomiciliationBancaire } from '@/model/domiciliations-bancaires';
import { ModeReglement } from '@/model/mode-reglement';
import { parseISO } from 'date-fns';
import { CustomConverter, JsonObject, JsonProperty, JsonTsMapper, Optional } from 'json-ts-mapper';
import StoreBuilder from '../store-builder';

@JsonObject
class ItemPanier {
  @JsonProperty(Number)
  idLigne: number

  @JsonProperty(ArticleLieuDepart)
  articleLieuDepart: ArticleLieuDepart;

  @JsonProperty(Number)
  quantite: number;

  @JsonProperty(Conditionnement)
  conditionnement: Conditionnement

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  echeanceLivraison: Date;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  echeancePaiement: Date;

  @JsonProperty(Adresse)
  adresse: Adresse;

  @JsonProperty(String)
  @Optional// todo remove
  codeCamion: string;

  @JsonProperty(String)
  @Optional// todo remove
  commentaireLivraison: string;

  @JsonProperty(ModeReglement)
  modeReglement: ModeReglement;

  @JsonProperty(DomiciliationBancaire)
  @Optional
  domiciliationBancaire: DomiciliationBancaire;

  @JsonProperty(Number)
  prixUnitaireHT: number;

  @JsonProperty(Number)
  prixUnitaireTTC: number;

  @JsonProperty(Number)
  prixTotalHT: number;

  @JsonProperty(Number)
  prixTotalTTC: number;
}

const builder = new StoreBuilder('panier');
builder.addStatePart('sequence_idLigne', 1, null, 'SESSION');
builder.addStatePart('items', [], null,
  {
    storageType: 'SESSION',
    serialize: (items: ItemPanier[]) => items ? JsonTsMapper.serializeToString(items) : '[]',
    deserialize: (str: string) => str ? JsonTsMapper.deserialize(str, ItemPanier) : []
  }
);
builder.addStatePart('dateModification', null, null,
  {
    storageType: 'SESSION',
    serialize: (date: Date) => date ? date.toISOString() : null,
    deserialize: (str: string) => str ? parseISO(str) : null
  }
);
builder.addStatePart('commentaireSaisie', { commentaire: null }, null, 'SESSION');

builder.setActions({
  ajouterItemPanier ({ state, dispatch }: any, item: ItemPanier) {
    item.idLigne = +state.sequence_idLigne;
    dispatch('setSequence_idLigne', item.idLigne + 1);
    dispatch('setItems', [...state.items, item]);
    dispatch('setDateModification', new Date());
  },
  modifierItemPanier ({ state, dispatch }: any, item: any) {
    const items: ItemPanier[] = state.items;
    const index = items.findIndex(i => i.idLigne === item.idLigne);
    if (index >= 0) {
      items[index] = item;
      dispatch('setItems', items);
      dispatch('setDateModification', new Date());
    } else {
      throw new Error('ItemPanier not found');
    }
  },
  suprimerItemPanier ({ state, dispatch }: any, idLigne: number) {
    const items: ItemPanier[] = state.items;
    const index = items.findIndex(i => i.idLigne === idLigne);
    if (index >= 0) {
      items.splice(index, 1);
      dispatch('setItems', items);
      dispatch('setDateModification', new Date());
    }
  },
  viderPanier: ({ dispatch }: any) => {
    dispatch('reset');
  }
});

export default builder.build();
export { ItemPanier };
